import styled from "styled-components";

export const DetailWrapper = styled.section`
  width: 300px;
  border: 1.5px solid #436ab2;
  padding: 20px 24px;
  border-radius: 10px;
  margin-right: 2rem;
  user-select: none;
`;

export const DetailWrapperHeader = styled.header`
  display: flex;
  align-items: center;
`;

export const NewFooterDiv = styled.div`
  background-color: ${(props) => props.theme.primaryColor};
`;

export const InsuranePlanWrapper = styled.section`
  user-select: none;
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: space-between;
  width: 40rem;
  background: #f5f8ff;
  border-radius: 15px;
  position: relative;
  transition: 0.2s all ease-in-out;
  /* height: 22rem; */
  /* &:hover {
    background-color: rgba(230, 237, 255, 0.6);
    transform: scale(1.005);
  } */
`;

export const Header = styled.header`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 36rem;
  & > img {
    transition: 0.2s all ease-in-out;
  }
  /* ${InsuranePlanWrapper}:hover & > img {
    transform: scale(1.1);
  } */
`;

export const Link = styled.footer`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  transition: 0.2s ease-in-out all;
`;
export const LinkNew = styled.footer`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`;

export const Image = styled.img`
  transition: transform 0.2s ease-in-out;
  height: 20px;
  margin-left: 0.4rem;
  ${Link}:hover & {
    transform: translateX(4px);
  }
`;

export const LinksWrapper = styled.section`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0rem 24px 30px 24px;
  justify-content: space-between;
`;

export const FooterElement = styled.footer`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  bottom: 0px;
  background-color: #f5f8ff;
  border-radius: 0 0 10px 10px;
`;

export const FooterButton = styled.div`
  height: 66px;
  display: flex;
  align-items: center;
  padding: 2rem;
  width: 100%;
  background-color: ${(props) => props.theme.primaryColor};
`;

export const Footer = styled.footer`
  /* padding: 20px 24px; */
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: relative;
  bottom: 0px;
  background-color: #d0d9e9;
  height: 80px;
  border-radius: 0 0 10px 10px;
  transition: 0.2s all ease-in-out;
  /* ${InsuranePlanWrapper}:hover & {
    background-color: #cbd5e7;
  } */
`;

export const BenefitCardWrapper = styled.section`
  border-radius: 12px;
  min-width: 320px;
  min-height: 160px;
  background-color: #f5f8ff;
  padding: 20px 24px;
  transition: 0.2s ease-in-out all;
  /* &:hover {
    background-color: rgba(230, 237, 255, 0.6);
    transform: scale(1.01);
  }
  &:hover > header > img {
    transform: scale(1.05);
  } */
`;

export const BenefitsWrapper = styled.section`
  display: flex;
  gap: 2rem;
  overflow: scroll;
  width: 100%;
  margin-top: 2rem;
  user-select: none;
  &::-webkit-scrollbar {
    display: none;
  }

  &::-webkit-scrollbar-thumb {
    display: none;
  }

  &::-webkit-scrollbar-track {
    display: none;
  }
`;

export const InsurerIcon = styled.img`
  max-width: 7rem;
  max-height: 3rem;
  object-fit: cover;
`;

export const SplitDetailCardWrapper = styled.section`
  background-color: ${(props) => props.theme.neoCardBgColor};
  width: ${(props) => (props.width ? props.width : "24rem")};
  padding: 2rem;
  border-radius: 10px;
`;
export const SplitDetailWrapper = styled.section`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  margin-top: 1rem;
  padding: 0.4rem 0rem;
  & > div {
    width: 40%;
  }
`;

export const VerticalDivider = styled.section`
  width: 1px;
  height: 4rem;
  background-color: #c6c2c2;
`;

export const ECardWrapper = styled.section`
  border-radius: 10px;
  flex-shrink: 0;
  overflow: hidden;
  display: flex;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
  width: max-content;
`;

export const ECardStrip = styled.aside`
  width: 20px;
  background-color: ${(props) => props.theme.primaryColor};
`;

export const ECardHeader = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ECardLink = styled.a`
  font-family: "Inter";
  color: ${(props) => props.theme.accentColor};
  font-size: 14px;
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;
`;

export const Line = styled.div`
  margin-top: 10px;
  height: 1px;
  background-color: #828080;
`;

export const ECardDetailWrapper = styled.section`
  display: grid;
  gap: 2rem;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 44px 44px 44px;
  padding: 2.4rem 4rem 2.4rem 2.8rem;
`;

export const ECardScroll = styled.section`
  margin-bottom: 2rem;
  padding: 24px;
  background-color: white;
  border-radius: 10px;
  max-width: 1100px;
  & > div::-webkit-scrollbar {
    display: none;
  }
`;

export const ECardRightSection = styled.div`
  margin-left: 2rem;
`;

export const InsurerLogoWrapper = styled.div`
  width: 90px;
  height: 30px;
  & > img {
    max-width: 90%;
    max-height: 90%;
  }
`;

export const SplitCardTag = styled.div`
  padding: 0.4rem 1.4rem;
  border-radius: 10px;
  width: min-content;
  background: #fac979;
`;
